// Library Import
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Local Imports

const API = import.meta.env.VITE_SERVER_CON_URL;

export const getToken = createAsyncThunk(
  "getToken",
  async ({ userDetails }) => {
    try {
      const response = await axios.post(`${API}/api/user/getToken`, {
        email: userDetails.email,
        name: userDetails.name,
      });

      return response.data;
    } catch (err) {
      return {
        err:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      };
    }
  }
);

export const getChallenges = createAsyncThunk("getChallenges", async () => {
  try {
    const response = await axios.get(`${API}/api/user/getChallenges`);

    return response.data.challenges;
  } catch (err) {
    return {
      err:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    };
  }
});

export const loginSignUp = createAsyncThunk(
  "loginSignUp",
  async (userDetails) => {
    try {
      const response = await axios.post(
        `${API}/api/user/loginSignUp`,
        userDetails
      );

      return response.data;
    } catch (err) {
      return {
        err:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      };
    }
  }
);

export const deleteUser = createAsyncThunk("deleteUser", async (email) => {
  try {
    const response = await axios.delete(`${API}/api/user/deleteUser/${email}`);

    return response.data;
  } catch (err) {
    return {
      err:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    };
  }
});

export const createResetPassword = createAsyncThunk(
  "createResetPassword",
  async (email) => {
    try {
      const response = await axios.post(`${API}/api/user/createResetPassword`, {
        email,
      });

      return response.data;
    } catch (err) {
      return {
        err:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      };
    }
  }
);

export const resetPassword = createAsyncThunk(
  "resetPassword",
  async ({ password, token }, { getState }) => {
    try {
      const response = await axios.put(`${API}/api/user/resetPassword`, {
        password,
        token,
      });

      return response.data;
    } catch (err) {
      return {
        err:
          err.response && err.response.data ? decrypted.message : err.message,
      };
    }
  }
);
